import { LaneType, LaneIntegrationType } from 'common-types';


import { PublicUserType } from './PublicUserType';
import { IWizardState } from './IWizardState';
import { ContentType } from '../content/Content';
import { ShopifyChannelType } from './ShopifyBurst';

export type ShopifyRsvpDraftInteractionData =
  Partial<LaneIntegrationType.ShopifyRsvpInteraction>;

export type ShopifyRsvpWizardState = Pick<
  IWizardState<ShopifyRsvpDraftInteractionData>,
  'data' | 'currentStepIndex'
>;

// Constants moved to constants-integrations
export { SHOPIFY_BURST_RSVP_VALID_DAYS } from 'constants-integrations';

export enum ShopifyBurstRsvpEntryTimeValidEnum {
  /** not sure yet if this is valid, we maybe loading the info */
  Unknown = 'Unknown',
  /** we have passed the entry time on this burst */
  Invalid = 'Invalid',
  /** the user is still allowed to submit */
  Valid = 'Valid',
}

export type ShopifyBurstInteractionCacheType = {
  contentId: string;
  contentName: string;
  contentDescription: string;
  contentData: object;
  features: object;
  interactionId: string;
  interactionStartDate: Date;
  interactionEndDate: Date;
};

export type ShopifyRsvpContentStateType = {
  shopifyBurstContentId: LaneType.UUID;
  shopifyBurstInteractionId: LaneType.UUID;
  attendees: PublicUserType[];
  l9?: PublicUserType;
  attendeesCount: number;
  name: LaneType.String;
  port?: ShopifyChannelType;
  portTimeZone?: string;
  dateRange: LaneType.DateTimeRange;
  dailySchedule?: LaneType.UserContentInteraction;
  primaryRoomBooking?: LaneType.UserContentInteraction;
  activitiesBookings?: Array<LaneType.UserContentInteraction>;
  dailyScheduleData?: ShopifyBurstInteractionCacheType;
  primaryRoomBookingData?: ShopifyBurstInteractionCacheType;
  activitiesBookingsData?: ShopifyBurstInteractionCacheType[];
  acknowledgementContent?: ContentType;
  burstNameContent?: ContentType;
  /** @deprecated this field was preserved for backward compatability with old mobile versions that work with only v1 schema */
  questionnaire: LaneType.ShopifyBurstQuestionnaireTypeV2;
  questionnaireInteraction?: any;
  questionnaireContent?: ContentType;
  /** @deprecated this field was preserved for backward compatability with old mobile versions that work with only v1 schema */
  specialRequest: string;
  specialRequestContent?: ContentType;
  specialRequestInteraction?: any;
  isDiyBurst?: boolean;
  diyQuestions?: any;
  diyQuestionsContent?: ContentType;
  schemaVersion?: number;
};

export type RSVPContent = ContentType & {
  state: {
    _ShopifyBurst: ShopifyRsvpContentStateType;
  };
  channelId: LaneType.UUID;
  placements?: { user?: { _id: LaneType.UUID } }[];
};

export enum ShopifyRsvpTabsEnum {
  Invited = 'invited',
  Declined = 'declined',
  Accepted = 'accepted',
}

// FIXME: Enum nesting is not valid for isolated modules
// Can we not just use the originl enum?
export enum ShopifyRsvpStatusEnum {
  /** -> Shopifolk responded Yes to RSVP */
  Accepted = 'Accepted', // INTERACTION_ACCEPTED,
  /** -> Shopifolk responded No to RSVP */
  Declined = 'Declined', // INTERACTION_DECLINED,
  /** -> The burst was cancelled */
  Cancelled = 'Cancelled', // INTERACTION_CANCELLED,
  /** -> The burst was confirmed */
  Confirmed = 'Confirmed', // INTERACTION_CONFIRMED,
  /** -> Awaiting response from Shopifolk member */
  Awaiting = 'Awaiting Response', // INTERACTION_AWAITING_RESPONSE,
}
